<template>
    <div>
        <v-card style="min-height:300px">
            <v-toolbar flat color="info" height="40" >
                <v-toolbar-title>
                    Customer Facility Picker
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon color="primary" @click.prevent="onPicked()">
                    <v-icon>clear</v-icon>
                </v-btn>
            </v-toolbar>
            <v-card-text>
                <v-form ref="frmFacilitySearch" v-model="formValid" lazy-validation>
                    <v-text-field
                        v-model="keyword" 
                        label="Enter Facility Acct. # or Customer Name or ZIP Code here"
                        :hint="keywordFieldHint"
                        persistent-hint
                        ref="txtKeyword"
                        :autofocus=true
                        ></v-text-field>
                </v-form>
            </v-card-text>
            <v-card-text v-show="entries.length">
                <!-- <v-layout row v-if="error">
                    <v-flex xs12>
                        <app-alert @dismissed="onDismissed" :text="error.message"></app-alert>
                    </v-flex>
                </v-layout>      -->
                <h3>Please Pick below:</h3>
                <v-data-table
                    :items="entries"
                    item-key="id"
                    :pagination.sync="pagination"
                    :rows-per-page-items="pagination.rowsPerPageItems"
                    disable-initial-sort
                    hide-headers
                >
                    <template slot="items" slot-scope="props">
                    <tr>
                        <td style="padding:1px;margin:1px">
                            <div v-for="terr in props.item.territories" :key="terr">
                                <v-btn large @click.prevent="onPicked(props.item.id, terr)" class="primary" style="padding:1px;margin:1px">
                                    Pick for
                                    <br>Terr: {{terr}}

                                </v-btn>

                            </div>

                        </td>
                        <td class="text-xs-left">
                            <div class="body-1">
                                #: {{ props.item.code }}
                                /
                                Name: {{ props.item.description }}
                            </div>
                            <div>
                                Bill To: {{ props.item.customerName}}
                            </div>
                            <div>
                                <i>
                                    Addr.: {{ props.item.address }}
                                </i>
                            </div>
                        </td>
                        <!-- <td class="text-xs-right">{{ props.item.totalMainSalesAmt? props.item.totalMainSalesAmt : 'n/a' | currency}}</td>
                        <td class="text-xs-right">{{ props.item.totalMainCommiAmt? props.item.totalMainCommiAmt : 'n/a' | currency}}</td>
                        <td class="text-xs-right">{{ props.item.totalMainPercent? props.item.totalMainPercent : '' }}</td>
                        <td class="text-xs-right">{{ props.item.createDate }}</td>
                        <td class="text-xs-right">{{ props.item.createBy }}</td> -->
                    </tr>
                    </template>
                </v-data-table>  
            </v-card-text>
        </v-card>
    </div>
</template>
<script>
import _ from 'lodash'

import { mapActions } from 'vuex'

export default {
    data () {
        return {
            formValid : false,
            keyword : '',
            minCharsToSearch : 3,
            rules: {
                required: v => !! v || 'This field is required'
            },
            entries: [],
            pagination: {
                descending: true,
                page: 1,
                rowsPerPage: 10,
                sortBy: 'fat',
                totalItems: 0,
                rowsPerPageItems: [10, 20, 50]
            },
            headers: [
                {width: '20%'}
                // {text: 'Acct. #', value: 'code'},
                // {text: 'Facility / Customer Name', value: 'description'},
                // {text: 'Address', value: 'address'},
                // {text: 'Main Sales Amt.', value: 'totalMainSalesAmt'},
                // {text: 'Main Commi. Amt.', value: 'totalMainCommiAmt'},
                // {text: 'Percent', value: 'totalMainCommiAmt'},
                // {text: 'Create', value: 'createDate'},
                // {text: 'By', value: 'createBy'}
            ],
        }
    },
    computed: {
        keywordFieldHint () {
            return `Need at least ${this.minCharsToSearch} characters to start search`
        }
    },
    methods: {
        ...mapActions('customerSearch',[
            'getFacilityByKeyWord'
        ]),
        onPicked(id, terrId) {
            this.$emit('onPicked', {id:id, terrId: terrId})
            // reset data
            this.keyword = ''
            this.entries = []
        },
        searchFacilities: _.debounce(async function (val) {
                    // if (this.searchCriteria.statusSelected === null || this.searchCriteria.statusSelected.length === 0) {
                    //     alert('Please select at least one status to search')
                    //     return
                    // }
                    // const jtSelected = this.searchCriteria.jobTypeSelected === 0
                    //     ? this.jobTypes.map(item => item.id)
                    //     : [this.searchCriteria.jobTypeSelected]
                    // const payload = Object.assign({}, this.searchCriteria, { jobTypeSelected: jtSelected })
                    // this.$store.dispatch('jobSearch/searchJobs', payload)
                    //     .then(data => {
                    //         this.jobs = data
                    //         // console.log('jobs' + this.jobs)
                    //     })
            if(!val || !val.length || val.length < 3)
                return

            // this.isLoading = true;

            let FacilitysFound = await this.getFacilityByKeyWord({keyword: val});
            console.log(`FacilitysFound: ${FacilitysFound.length}`)
            this.count = FacilitysFound.length
            this.entries = FacilitysFound
    
            this.$refs.txtKeyword.focus()

            // this.isLoading = false
        }, 1000),
    },
    watch: {
        keyword : function(newVal, oldVal) {
            this.searchFacilities(newVal)
        }
    },
    mounted() {
        this.$refs.txtKeyword.focus()
    }
}
</script>
